import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApiPaginationResult } from '../../shared/models/api-result.model';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private http = inject(HttpClient);

  private apiBaseUrl = environment.apiBaseUrl;

  getSummary() {
    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl + `/api/v1/dashboards/summary`,
    );
  }
}
